import React, { useEffect, useState } from "react";
import { TeacherInterface } from "../../interfaces/teacher.interface";
import { get, post } from "../../redux/ApiHelper";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { successToast } from "../../utils/toast.util";

const TeacherDetailsAccessComponent = ({ row }: { row: TeacherInterface }) => {
  const [status, setStatus] = useState<{
    isRequested: boolean;
    requestAccess: string;
  }>({
    isRequested: false,
    requestAccess: "pending",
  });
  const { signedAdmin } = useSelector((state: RootState) => state.admin);
  const [loading, setLoading] = useState(false);

  const getStatus = async () => {
    try {
      const res = await get("/admin/teacher/access-of-details-status", {
        teacherId: row._id,
        adminId: signedAdmin.id,
        type: signedAdmin.type,
      });
      console.log("res", res);
      setStatus({
        isRequested: res.isRequested,
        requestAccess: res.accessRequest,
      });
    } catch (error) {}
  };

  useEffect(() => {
    getStatus();
  }, [row._id, signedAdmin.id, signedAdmin.type, loading]);

  function renderStatusText(status) {
    switch (status) {
      case "pending":
        return <span className="text-yellow-500">Pending</span>;
      case "accepted":
        return <span className="text-green-600">Accepted</span>;
      case "rejected":
        return <span className="text-red-500">Rejected</span>;
      default:
        return <span className="text-gray-400">Unknown</span>;
    }
  }

  const handleClickRequest = async () => {
    try {
      setLoading(true);
      const res = await post("/admin/teacher/request-access", {
        adminId: signedAdmin.id,
        teacherId: row._id,
        type: signedAdmin.type,
      });
      // console.log(res);
      successToast(res.message);
    } catch (error) {}
    setLoading(false);
  };
  return (
    <div>
      {status.isRequested ? (
        <div>
          <p className="italic">
            status:{renderStatusText(status.requestAccess)}
          </p>
          {status.requestAccess === "accepted" && (
            <div>
              <p className="underline">Teacher Details:</p>
              <p>
                <span className="font-bold">Email:</span>
                {row.email}
              </p>
              <p>
                <span className="font-bold">PhoneNo:</span>
                {row.phoneNumber}
              </p>
            </div>
          )}
        </div>
      ) : (
        <div>
          {" "}
          <p className="italic">
            Request to administrator for more teacher details{" "}
          </p>
          <button
            className="text-blue-500 bg-gray-200 hover:text-white capitalize"
            onClick={handleClickRequest}
          >
            Send Request
          </button>
        </div>
      )}
    </div>
  );
};

export default TeacherDetailsAccessComponent;
